<template>
  <div>
    <p><i class="el-icon-s-grid"></i>新增活码<el-button type="primary" icon="el-icon-back" size="mini" @click="goback()">返回</el-button></p>
    <el-divider></el-divider>
    <el-row>
      <el-col :span="24">
        <el-form ref="addform" :model="form" :rules="rules" label-width="100px" label-position="left" style="max-width: 50rem;">
          <el-form-item label="活码名称" prop="qr_title">
            <el-input v-model="form.qr_title"></el-input>
            活码名称将显示在用户标题栏上
          </el-form-item>
          <el-form-item label="活码类型" prop="type">
              <el-radio-group v-model="form.type" @change="typeChange">
                <el-radio :label="1">客服码</el-radio>
                <el-radio :label="2">群活码</el-radio>
                <el-radio :label="3">链接码</el-radio>
                <el-radio :label="4">文档码</el-radio>
                <el-radio :label="5">口令码</el-radio>
                <el-radio :label="6">分组码</el-radio>
              </el-radio-group>
            <p>客服码（快速引流到个人号）；群活码（分流用户到群及裂变活动）；链接码（广告、链接投放）；</p>
            <p>文档码（可文字、图片、口令同时展示）；口令码（口令助力推广、文字复制）；分组码（页面可以设置不同标签）</p>
          </el-form-item>
          <!-- <el-form-item label="备注">
            <el-input v-model="form.remark"></el-input>
            活码的备注信息，用户不可见
          </el-form-item> -->
          <el-form-item label="循环展示" v-show="form.type != 6">
            <el-switch v-model="form.xunhuan"></el-switch>
            <p>子码扫码次数清空重新开始统计，无限循环展示</p>
          </el-form-item>
          <el-form-item label="最大扫码次数" v-show="form.type != 6">
            <el-switch v-model="form.qr_maxscan"></el-switch>
            <p>在开启循环模式的条件下，开启后子码达到设定的最大次数后此子码不可用</p>
          </el-form-item>
          <el-form-item label="防止重复加人" v-show="form.type != 6">
            <el-switch v-model="form.cf_status"></el-switch>
            <p>用户第一次扫描活码会被系统绑定，将无法看到其它的二维码</p>
          </el-form-item>
          <el-form-item label="显示模式" prop="moshi" v-show="form.type != 6">
              <el-radio-group v-model="form.moshi">
                <el-radio :label="1">顺序展示</el-radio>
                <el-radio :label="2">随机展示</el-radio>
              </el-radio-group>
            <p>顺序展示: 子码按照顺序展示;随机展示: 子码不按照顺序展示</p>
          </el-form-item>
          <el-form-item label="引导语开关">
            <el-switch v-model="form.yd_status" @change="ydykaiguan($event)"></el-switch><br />
            <span>可在活码页展示引导文字内容</span>
          </el-form-item>
          <el-form-item label="引导语" v-show="ydyVisible">
            <el-input v-model="form.yindaoyu"></el-input>
          </el-form-item>
          <el-form-item label="安全验证提示">
            <el-switch v-model="form.yz_status"></el-switch>
            <p>在活码页顶部显示二维码已通过安全验证，增加可信度</p>
          </el-form-item>
          <el-form-item label="分组码图片" v-show="form.type==6">
            <el-image
              style="width: 100px; height: 100px"
              :src="fzimgurl(form.fzimage)"
              fit="fill">
            </el-image>
            <el-upload
              action="/api/main/upimgf"
              accept="image/png,image/jpeg"
              :headers="upheaders"
              :multiple="false"
              :show-file-list="false"
              :on-success="upsuccess">
              <el-button>上传</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('addform')">保存</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>
<script>
  import {qrSave1} from '../../api/userMG'
  export default {
    data() {
      return{
        form: {
                qr_title: '',
                type:'',
                remark: '',
                xunhuan: false,
                qr_maxscan: false,
                cf_status: false,
                yd_status: false,
                yindaoyu: '',
                yz_status: false,
                moshi: null,
                fzimage: '',
                token: localStorage.getItem('logintoken')
        },
        upheaders:{
          'ContentType':'multipart/form-data',
          'token': localStorage.getItem('token')
        },
        rules: {
                  qr_title: [
                    { required: true, message: '请输入活码名称', trigger: 'blur' },
                    { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
                  ],
                  type: [
                    { required: true, message: '请选择活码类型', trigger: 'change' }
                  ],
                  moshi: [
                    { required: true, message: '请选择显示模式', trigger: 'change' }
                  ]
        },
        ydyVisible: false,
      }
    },
    methods: {
      submitForm(formName) {
        let _that = this
        _that.$refs[formName].validate((valid) => {
          if (valid) {
            qrSave1(_that.form).then(res=>{
              if(res.code == 1){

                _that.$message({
                  type: 'success',
                  message: res.msg,
                  onClose:function(ele){
                    _that.goback()
                  }
                })
              }else{
                _that.$message({
                  type: 'info',
                  message: res.msg
                })
              }

            }).catch(err=>{
              _that.$message.error('操作数据失败')
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      fzimgurl(url){
        if(url){
          return this.$yuanUrl + url
        }else{
          return '/static/upload.png'
        }
      },
      //子码上传成功
      upsuccess(response, file, fileList){
        console.log(response)
        if(response.code == '0'){
          this.form.fzimage = response.url
          this.$message.success("上传成功！")
        }
      },
      goback() {
        this.$router.go(-1);
      },
      ydykaiguan(callback){
          this.ydyVisible = callback;
      },
      typeChange(val){
          if(val == '6'){
            this.form.moshi = 1
          }
      }

    },
    created() {
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/huoma/addQrcode.vue